<template>
  <v-sheet :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-container class="main-container responsive-height">
      <v-row dense>
        <v-col cols="12" xl="12">
          <v-card elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'" class="all-trade-tab rounded-0 mb-0 px-0">
            <v-tabs
              :background-color="
                $vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
              class="pa-0"
            >
              <v-tab class="ml-0"> Dashboard</v-tab>
              <!-- <v-tab> Trading Market </v-tab> -->

              <v-tab-item>
                <v-card flat class="mb-0" :color="$vuetify.theme.dark ? '#131C29' : '#E0EAF2'">
                  <dashboard-tab></dashboard-tab>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat class="mb-0" :color="$vuetify.theme.dark ? '#131C29' : '#E0EAF2'">
                  <TradingMarketTab></TradingMarketTab>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import DashboardTab from "@/components/TradeMaster/DashboardTab.vue";
import TradingMarketTab from "@/components/TradeMaster/TradingMarketTab.vue";

export default {
  data: () => ({}),
  components: {
    DashboardTab,
    TradingMarketTab,
  }
};
</script>
